/**
 * WordPress dependencies
 */
import { createReduxStore, register } from "@wordpress/data";
/**
 * Internal dependencies
 */
import * as actions from "./actions";
import reducer from "./reducer";
import * as selectors from "./selectors";


const STORE_NAME = "ebs/add-to-cart";

// Capture concrete namespace types BEFORE TypeScript widens them through the
// `MapOf<ActionCreator>` index-signature constraint on ReduxStoreConfig.
// Without this cast, PromisifiedActionCreators loses literal method names.
type ConcreteActions   = typeof actions;
type ConcreteSelectors = typeof selectors;

const config = { actions, reducer, selectors };

export const store = createReduxStore(
	STORE_NAME,
	config as { actions: ConcreteActions; selectors: ConcreteSelectors } & typeof config,
);

register( store );

export { STORE_NAME };
export default store;
